exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".複製連結{font-size:80%;height:21.15px;width:68.66px;margin-left:-30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/複製連結鍵/複製連結鍵.css
// module id = 662
// module chunks = 0